import { useMutation, useQuery } from "@tanstack/react-query"
import { useSearchParams } from "react-router-dom"
import GameScreenLayout from "@/components/GameScreenLayout"
import GeoPointsList from "@/components/geo/GeoPointsList"
import { normalizeGeoPoint } from "@/components/geo/geoPointHelpers"
import { usePlayerGpsState } from "@/hooks/usePlayerGpsState"
import { claimTreasure, getTreasurePoints } from "@/api/gameApi"
import { getGameApiErrorMessage } from "@/api/gameApiErrors"
import { useGuardiansPassport } from "@/features/passport/GuardiansPassportContext"
export default function TreasurePage() {
  const [params] = useSearchParams()
  const highlightId = params.get("pointId")
  const gps = usePlayerGpsState()
  const { syncGameState } = useGuardiansPassport()

  const q = useQuery({
    queryKey: ["treasure-points"],
    queryFn: getTreasurePoints,
  })

  const claim = useMutation({
    mutationFn: (pointId: string) => {
      if (!gps) throw new Error("GPS")
      return claimTreasure({
        pointId,
        playerLat: gps.lat,
        playerLng: gps.lng,
      })
    },
    onSuccess: async () => {
      await syncGameState()
      void q.refetch()
    },
  })

  const points = (q.data?.points ?? []).map((p) =>
    normalizeGeoPoint({
      id: p.id,
      name: p.name,
      latitude: p.latitude,
      longitude: p.longitude,
      radiusMeters: p.radiusMeters,
      isAvailable: p.isActiveNow,
      meta: p.kind,
    })
  )

  return (
    <GameScreenLayout title="Клады / звездопад" backTo="/play/map">
      {q.data?.claimedToday ? (
        <p className="mb-2 text-xs text-guardians-muted">Клад сегодня уже брали</p>
      ) : null}
      <GeoPointsList
        points={points}
        gps={gps}
        highlightId={highlightId}
        renderActions={({ point, inRange }) => (
          <button
            type="button"
            disabled={!inRange || claim.isPending}
            onClick={() => claim.mutate(point.id)}
            className="rounded-lg bg-guardians-accent px-3 py-1.5 text-xs text-guardians-bg disabled:opacity-40"
          >
            Забрать
          </button>
        )}
      />
      {claim.isError ? (
        <p className="mt-3 text-sm text-red-300">
          {getGameApiErrorMessage(claim.error, "Не удалось")}
        </p>
      ) : null}
      {claim.data ? (
        <p className="mt-3 text-sm text-green-300">
          +{claim.data.coins} монет
          {claim.data.dust > 0 ? `, +${claim.data.dust} пыли` : ""}
        </p>
      ) : null}
    </GameScreenLayout>
  )
}
